import React, { useEffect } from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectAuthUser } from '../auth/AuthSlice';
import { IS_STRIPE_TEST } from '../../app/const';
import { Button, ButtonGroup, Typography } from '@mui/material';

const PricingHome = () => {
  const authUser = useAppSelector(selectAuthUser)
  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://js.stripe.com/v3/pricing-table.js"
    script.async = true
    document.body.appendChild(script)
    return () => { document.body.removeChild(script) }
  }, [])

  const StripeTable = () => React.createElement("stripe-pricing-table", {
    "pricing-table-id": IS_STRIPE_TEST ? `prctbl_1NxlFmJdcrvOgF87T5GPba8c` : `prctbl_1Ny5YrJdcrvOgF87LwGF0fDr`,
    "publishable-key": IS_STRIPE_TEST ? `pk_test_51NnMY4JdcrvOgF87BlPWWUx8AmngW8XjLEfcGPnOHnJdZIFzO1zl6RDP6K4yWVaLtbM68VgsWfK0g7BmS1hX74tg00VO2uG09K`
      : `pk_live_51NnMY4JdcrvOgF87BWZFUwSsHojE3pQ98xXtNQ29metNbQdSnoTBEWVlh9VRLKF0pLw2HlOOs8SzAawSrDr991Na00NGUttWLt`,
    "client-reference-id": authUser?.uid
  })

  return (<>
    <Typography variant="h5" align="center">Existing subscriptions</Typography>
    <ButtonGroup>
      <Button href={IS_STRIPE_TEST ? `https://billing.stripe.com/p/login/test_9AQ02S96S3aFcjCdQQ`
        : `https://billing.stripe.com/p/login/fZe6qC43paRza5O000`}>Modify</Button>
    </ButtonGroup>
    <StripeTable />
  </>)
}

export default PricingHome